import { render, staticRenderFns } from "./AuctionViewGlobal.vue?vue&type=template&id=40bd98c4&"
import script from "./AuctionViewGlobal.vue?vue&type=script&lang=js&"
export * from "./AuctionViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports